import {
  PRODUCT_IMMERSI_LEARN,
  PRODUCT_THE_NEXT_GEN,
  PRODUCT_VIRTUAL_PATHS,
  PRODUCT_XRLAB_360,
} from "../../vue/helpers/page-constants";

export const productIntroLogoMapping = {
  [PRODUCT_VIRTUAL_PATHS]: "/images/header/virtupaths_logo.svg",
  [PRODUCT_IMMERSI_LEARN]: "/images/header/immerse_logo.svg",
  [PRODUCT_XRLAB_360]: "/images/header/xrlab360_logo.svg",
  [PRODUCT_THE_NEXT_GEN]: "/images/header/thenextgenxr_logo.svg",
};
